module.exports = __webpack_public_path__ + "static/media/lBanner4.3860851f.png";